// @flow
import { styled } from 'goober';
import { useState, useEffect } from 'preact/hooks';
import MuiInput from '../material-ui/muiInput';
import SaCustomButton from './SaCustomButton';
import { useSalesAppTracker } from './tracker';

const MobileNumberContainer = styled('div')`
  .container {
    padding: 50px 16px 30px 16px;
  }
  .heading {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--primaryCTAColor);
  }
  .subHeading {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    padding: 10px 0px 15px;
    color: #636363;
  }
  .btnContainer {
    margin: 45px 0px 0px;
    display: flex;
    justify-content: center;
  }
`;
const MobileNoContainer = styled('div')`
  .mdc-text-field--outlined .mdc-floating-label {
    border-color: #000000;
  }
  .mobileNoPrefix {
    position: absolute;
    z-index: 1;
    display: inline-block;
    height: 30px;
    padding: 4px 4px 0px 15px;
    width: 39px;
    text-align: center;
    top: 11px;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.1px;
  }
  .mobileInputWrapper {
    position: relative;
  }
  .mobileInputWrapper input {
    text-align: left !important;
    padding-left: 60px !important;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.1px;
  }
`;
const EnterMobileNumberScreen = ({
  btnTxt,
  btnHandler,
  mobileNo,
  onChangeHandler,
  loading,
  isMobileVerified,
}) => {
  const [prefix, showPrefix] = useState(false);
  const pageKey = 'sa_pv_mobile_modal';
  const salesAppTracker = useSalesAppTracker(pageKey);
  useEffect(() => {
    salesAppTracker.trackPageView('sa_pv_mobile_modal');
  }, []);
  return (
    <MobileNumberContainer>
      <div className='container'>
        <div className='heading'>Customer's Mobile Number</div>
        <div className='subHeading'>
          Enter customer's mobile number registered with their bank
        </div>
        <MobileNoContainer>
          <div className='mobileInputWrapper'>
            {(prefix || mobileNo) && (
              <span className='mobileNoPrefix'>+91-</span>
            )}
            <MuiInput
              className='mdc-text-field--focused'
              label='Mobile No.'
              outlined
              autoFocus={true}
              type='tel'
              inputName='mobile'
              inputID='mobile'
              elementName='User Mobile'
              maxLength={10}
              inputValue={mobileNo}
              onfocusin={() => showPrefix(true)}
              onfocusout={() => {
                if (!mobileNo) {
                  showPrefix(false);
                }
              }}
              onChange={(e) => {
                const mobileNumber = e.target.value;
                onChangeHandler(
                  mobileNumber ? mobileNumber.replace(/[^0-9]/g, '') : '',
                );
              }}
            />
          </div>
        </MobileNoContainer>
        <div className='subHeading helpText'>
          5-digit Secure Share Code will be sent on this number for verification
          and checking EMI eligibility
        </div>
        {isMobileVerified && (
          <div style={{ color: 'var(--primaryCTAColor)', fontSize: '13px' }}>
            You have already verified this mobile number, please check the
            eligibility
          </div>
        )}
        <SaCustomButton
          disable={mobileNo.length !== 10}
          onClick={() => {
            salesAppTracker.trackClick(
              'sa_click_generate_share_code',
              undefined,
            );
            btnHandler();
          }}
          name={btnTxt}
          loading={loading}
          containerClass='btnContainer'
        />
      </div>
    </MobileNumberContainer>
  );
};
export default EnterMobileNumberScreen;



// WEBPACK FOOTER //
// ./components/salesApp/EnterMobileNumberScreen.js